module.exports = __webpack_public_path__ + "img/chanpin_3@2x.115f13a2.png";